<template>
  <t-notification></t-notification>
  <header>
    <t-header></t-header>
  </header>
  
  <div class="top-margin-value">

    <slot />
  </div>
  <footer><TFooter></TFooter></footer>

  <Dialog v-model:visible="display" :modal="true">
    Network was interrupted while re-authenticating. Do you want to retry?
    <template #footer>
      <TButton @click= 'closeDialog()' label="No" class="p-button p-component secondary-color"/>
      <TButton @click = 'refreshToken(timer)' label="Yes" autofocus class="p-button p-component primary-color"/>
    </template>
  </Dialog>

</template>

<script>
// import THeader from "./../../common/components/layouts/header/THeader";
// import TFooter from "./../../common/components/layouts/footer/TFooter";
import TButton from "./../../common/components/buttons/TButton";
import TNotification from "./../components/TNotification";
import {REFRESH_TOKEN} from '../../domains/authentication/store/actions';
import GeneralVariables from '../utils/GeneralVariables';
// import Dialog from 'primevue/dialog';

import { defineAsyncComponent } from 'vue'
const Dialog = defineAsyncComponent(() =>
  import('primevue/dialog')
)
const TFooter = defineAsyncComponent(() =>
  import('./../../common/components/layouts/footer/TFooter')
)
const THeader = defineAsyncComponent(() =>
  import('./../../common/components/layouts/header/THeader')
)


const SECOND_TO_MILLISECONDS = 1000
const MINUTES_TO_SECONDS = 60
export default {
  setup() {},
  components: {
    THeader,
    TFooter,
    TButton,
    TNotification,
    Dialog,
  
  },
  methods:
  {
    // startTimer(timer,timeStep)
    // {
    //   setInterval(function(){ 
    //     timer.time += timeStep/SECOND_TO_MILLISECONDS
    //   }, timeStep);
    // },
    refreshToken(timer){
      let This = this
      this.$store.dispatch(REFRESH_TOKEN).then(
        ()=>{
          timer.active = true
          This.display = false
        }
      ).catch(
        (error)=>{
          if (error.message=="Network Error"||error.status==408){
            This.display = true
          }
          timer.active = true 
        }
      )
    },
    refreshTokenIfTimerExpired(timer,timeStep)
    {
      if (Date.now()-localStorage.getItem("refreshTime")>timeStep&&timer.active&&localStorage.getItem("refresh_token")!=null)
      {
        timer.active=false
        this.refreshToken(timer)
      }
    },
    closeDialog()
    {
      this.display = false
    }
  },
  data(){
    return{
      display:false,
      timer:{},
    }
  },
  mounted()
  {
    
    let This = this
    
    //this.timer.time = localStorage.getItem("refreshTime")
    //this.timer.oldTime = localStorage.getItem("refreshTime")
    this.timer.active = true
    let timeStep = GeneralVariables.TOKEN_REFRESH_TIME_IN_MINUTES*MINUTES_TO_SECONDS*SECOND_TO_MILLISECONDS
    
    
    //this.startTimer(this.timer,SECOND_TO_MILLISECONDS)

    window.addEventListener("mousemove",function(){
        This.refreshTokenIfTimerExpired(This.timer,timeStep)
      }
    )
    window.addEventListener("keydown",function(){
        This.refreshTokenIfTimerExpired(This.timer,timeStep)
      }
    )
    window.addEventListener('touchmove', function(){
        This.refreshTokenIfTimerExpired(This.timer,timeStep)
    })
  }
};
</script>

<style lang="scss" scoped>
.top-margin-value {
  display: table;
  margin-top: 100px;
  min-height: 60vh;
  width: 100vw;
  overflow:auto;
  @media screen and (max-width:900px) {
    margin-top: 60px;
  }
}


</style>
